<template lang="pug">
    .previously-purchased-items(
        ref="container"
        @scroll="handleScroll"
        v-dragscroll
    )
        table
            tr.product-table-row
                td.divider(colspan="5")
                    hr
            purchased-item-preview(
                v-for="item in pagination.items" :key="item.id"
                :item="item"
                @create-coupon="$emit('create-coupon', $event)"
                @ask-for-refund="$emit('ask-for-refund', $event)"
            )
        .drawer-spinner-container(v-if="loading")
            .spinner-background
                .spinner
</template>

<i18n>
{
    "de": {
        "Could not find anything": "Es konnte nichts gefunden werden"
    }
}
</i18n>

<script>
import { useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores'

import PurchasedItemPreview from './PurchasedItemPreview'

export default {
    name: 'PreviouslyPurchasedItems',
    props: {
        customer: {
            type: Object,
            required: true,
        },
        initializing: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        loading: false,
        pagination: {
            filters: {},
            includeStocks: false,
            includeImages: true,
            includePointOfSalePurchases: true,
            includeWebShopPurchases: true,
            pageInfo: {
                total: 0,
                perPage: 12,
                currentPage: 1,
                lastPage: 0,
            },
            items: []
        }
    }),
    components: {
        PurchasedItemPreview,
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        posSetupStore() {
            return usePosSetupStore();
        },
        posCartStore() {
            return usePosCartStore();
        }
    },
    methods: {
        async loadPurchasedItems(page = 1) {
            this.$set(this.pagination.pageInfo, 'currentPage', page)

            if (!this.pagination.filters) {
                this.$set(this.pagination, 'filters', {})
            }
            this.$set(this.pagination.filters, 'shop', {
                key: 'shop',
                match: this.activeCms.shop.id
            })
            this.$set(this.pagination.filters, 'customer', {
                key: 'customer',
                match: this.customer.id
            })

            const paginatedPurchasedItems = await this.posCartStore.fetchPurchasedItemsPaginated(this.pagination)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    console.error(err)
                })

            if (paginatedPurchasedItems.items && paginatedPurchasedItems.items.length) {
                if (page > 1) {
                    this.pagination.items =
                        [...this.pagination.items, ...paginatedPurchasedItems.items]
                } else {
                    this.pagination = paginatedPurchasedItems;
                    // this.$emit('update-visibility', true)
                    this.$emit('update:initializing', false)
                    // this.updateAutofocusSearchInput(false)
                    // this.$emit('blur-search')

                    this.$nextTick(() => {
                        if (this.$refs.container) {
                            // this.$refs.container.style['scroll-behavior'] = 'smooth';
                            this.$refs.container.scrollTop = 0
                        }
                        this.loadMoreIfNeeded(this.$refs.container)
                        // console.log(this.$refs.container)
                    })
                }
                this.loading = false;
            } else {
                this.$emit('update-visibility', false)
                this.$notify.error({
                    title: this.$t('Could not find anything'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            }
        },
        handleScroll(event) {
            const { target } = event;
            this.loadMoreIfNeeded(target)
        },
        loadMoreIfNeeded(target) {
            const currentPage = this.pagination.pageInfo.currentPage;
            if (this.loading === false && this.pagination.pageInfo.lastPage > currentPage) {

                let loadMore = false;
                const offset = 40;

                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) {
                    loadMore = true;
                }

                if (loadMore) {
                    this.loadPurchasedItems(currentPage + 1);
                }
            }
        }
    },
    mounted() {
        this.$emit('update:initializing', true)
        this.loadPurchasedItems()
    },
}
</script>

<style lang="sass" scoped>
.previously-purchased-items
    height: 100%
    overflow-y: auto
.previously-purchased-items table
    width: 100%
    border-spacing: unset
    &::v-deep
        .dimmed
            color: $color-grey-text
        .divider hr
            opacity: 0.5

        .property-container
            display: flex
            gap: 4px
            .property-value
                padding: 4px 6px
                background: darken($color-skeleton, 10%)
                border-radius: 4px
                font-size: 0.85em
                label
                    font-size: 0.8em
                    display: block
                    &:after
                        content: ''

        .actions
            .delete-item
                margin-left: 2rem

        td
            // vertical-align: top
            padding: 2px 0.4rem
            &.info
                padding-left: 0
            &.min
                width: 1px
        tr.product-table-row >
            td, th
                &:first-child
                    padding-left: 0
                &:last-child
                    padding-right: 0
</style>
